if (!window.customElements.get('competitor-comparison')) {
  class CompetitorComparison extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('[data-scroll]');
      this.wrap = this.querySelector('.competitor-comparison__table-wrap');
      this.toggle = this.querySelector('[data-toggle]');
      this.label = this.querySelector('[data-toggle-label]');
      this.rows = Array.from(this.querySelectorAll('[data-row]'));

      if (!this.scroller || !this.wrap || !this.toggle) return;

      this.limit = parseInt(this.dataset.rowsBeforeToggle, 10) || 8;
      if (!this.rows[this.limit]) return;

      this.expanded = false;
      this._onToggle = this._onToggle.bind(this);
      this._onReflow = this._onReflow.bind(this);

      this.toggle.addEventListener('click', this._onToggle);

      if (window.ResizeObserver) {
        this._observer = new ResizeObserver(this._onReflow);
        this._observer.observe(this.wrap);
      }
      window.addEventListener('resize', this._onReflow);

      this._collapse(false);

      requestAnimationFrame(() => this.setAttribute('data-ready', ''));
    }

    disconnectedCallback() {
      if (this.toggle) this.toggle.removeEventListener('click', this._onToggle);
      if (this._observer) this._observer.disconnect();
      window.removeEventListener('resize', this._onReflow);
      clearTimeout(this._settleTimer);
    }

    _collapsedHeight() {
      const row = this.rows[this.limit];
      if (!row) return 0;
      const offset = row.getBoundingClientRect().top - this.wrap.getBoundingClientRect().top;
      return Math.round(offset + Math.min(row.offsetHeight, 26));
    }

    _collapse(animate) {
      const height = this._collapsedHeight();
      if (!height) return;

      if (animate) {
        this.scroller.style.maxHeight = this.scroller.scrollHeight + 'px';
        void this.scroller.offsetHeight; // force reflow so the transition runs
      }

      this.scroller.style.maxHeight = height + 'px';
      this.expanded = false;
      this.removeAttribute('data-expanded');
      this.toggle.setAttribute('aria-expanded', 'false');
      if (this.label) this.label.textContent = this.toggle.dataset.more;
    }

    _expand() {
      this.scroller.style.maxHeight = this.scroller.scrollHeight + 'px';
      this.expanded = true;
      this.setAttribute('data-expanded', '');
      this.toggle.setAttribute('aria-expanded', 'true');
      if (this.label) this.label.textContent = this.toggle.dataset.less;

      clearTimeout(this._settleTimer);
      this._settleTimer = setTimeout(() => {
        if (this.expanded) this.scroller.style.maxHeight = 'none';
      }, 400);
    }

    _onToggle() {
      if (this.expanded) {
        this._collapse(true);
      } else {
        this._expand();
      }
    }

    _onReflow() {
      if (!this.expanded) this._collapse(false);
    }
  }

  customElements.define('competitor-comparison', CompetitorComparison);
}
